var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "w-100",
    },
    [
      _c(
        "b-modal",
        {
          staticClass: "px-0",
          attrs: {
            id: "bv-modal-result",
            size: "xl",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _vm._v(" สรุปรายการ " + _vm._s(_vm.gameMasterName) + " "),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "hide-overlay": "",
                persistent: "",
                "max-width": "290",
              },
              model: {
                value: _vm.dialogSubmit,
                callback: function ($$v) {
                  _vm.dialogSubmit = $$v
                },
                expression: "dialogSubmit",
              },
            },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    color: "red",
                    dark: "",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _vm._v("\n          กำลังประมวลผล\n          "),
                      _c("v-progress-linear", {
                        staticClass: "mb-0",
                        attrs: {
                          indeterminate: "",
                          color: "white",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-block text-center",
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-body mt-0 px-1 py-0 text-center",
                },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "text-md text-center py-1 my-0 text-primary",
                    },
                    [
                      _vm._v(
                        "\n          กรุณาตรวจสอบความถูกต้องก่อนกดยืนยันรายการทุกครั้งเพื่อประโยชน์สูงสุดของท่าน\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.gameMasterId == 1
                    ? _c(
                        "h1",
                        {
                          staticClass:
                            "text-md text-center py-1 my-0 text-primary",
                        },
                        [
                          _vm._v(
                            "\n          ** เรทจ่าย ณ ตอนนี้ ยังไม่ถือเป็นที่สิ้นสุด กรุณาตรวจสอบความถูกต้องที่รายการโพยอีกครั้ง หลังส่งโพยสำเร็จ **\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.accepTants, function (acceptant) {
                    return _c(
                      "div",
                      {
                        key: acceptant.slug,
                      },
                      [
                        _vm._filter(_vm.lottoNumbersWithType, [
                          "type",
                          acceptant.slug,
                        ]).length > 0
                          ? _c("div", [
                              _c(
                                "h1",
                                {
                                  staticClass:
                                    "text-xl bg-yellow text-black text-left py-2 px-2 mb-0",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(acceptant.display) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex text-lg py-1 border-top bg-black text-white",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-20x border-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-lg text-monospace",
                                        },
                                        [_vm._v("เลข")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-20x border-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-lg text-monospace",
                                        },
                                        [_vm._v("จำนวน")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  acceptant.slug == "4upper"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "w-60x",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-lg text-monospace",
                                            },
                                            [_vm._v("จำนวนชุด")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  acceptant.slug != "4upper"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "w-20x border-right",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-lg text-monospace",
                                            },
                                            [_vm._v("จ่าย")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  acceptant.slug != "4upper"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "w-40x",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-center text-lg text-monospace",
                                            },
                                            [_vm._v("ชนะ")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(
                            _vm._filter(_vm.lottoNumbersWithType, [
                              "type",
                              acceptant.slug,
                            ]),
                            function (lottoNumber, index) {
                              return _c("bet-recap", {
                                key: index,
                                staticClass: "w-100",
                                attrs: {
                                  item: lottoNumber,
                                  "master-slug": _vm.gameMasterName,
                                },
                                on: {
                                  "update:item": function ($event) {
                                    lottoNumber = $event
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex",
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex-width mx-1",
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 btn-danger w-100",
                      attrs: {
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("bv-modal-result")
                        },
                      },
                    },
                    [_vm._v(" ปิด ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex-width mx-1",
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 btn-success w-100",
                      attrs: {
                        block: "",
                      },
                      on: {
                        click: _vm.onConfirm,
                      },
                    },
                    [_vm._v(" ยืนยัน ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "bv-modal-template",
            size: "xl",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(" บันทึกรายการ ")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-block text-center",
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-body mt-0 px-1 py-0 text-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-group text-left",
                    },
                    [
                      _c(
                        "label",
                        {
                          attrs: {
                            for: "exampleFormControlInput1 text-left",
                          },
                        },
                        [_vm._v("ชื่อรายการ")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "templateName",
                        staticClass: "form-control",
                        attrs: {
                          id: "templateName",
                          name: "templateName",
                          type: "text",
                          placeholder: "กรอกชื่อรายการ",
                          required: "required",
                        },
                        domProps: {
                          value: _vm.templateName,
                        },
                        on: {
                          keyup: function ($event) {
                            return _vm.updateTemplate($event)
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.accepTants, function (acceptant) {
                    return _c(
                      "div",
                      {
                        key: acceptant.slug,
                      },
                      [
                        _vm._filter(_vm.lottoNumbersWithType, [
                          "type",
                          acceptant.slug,
                        ]).length > 0
                          ? _c("div", [
                              _c(
                                "h1",
                                {
                                  staticClass:
                                    "text-xl bg-yellow text-black text-left py-2 px-2 mb-0",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(acceptant.display) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex text-lg py-1 border-top bg-black text-white",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-20x border-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-lg text-monospace",
                                        },
                                        [_vm._v("เลข")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-20x border-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-lg text-monospace",
                                        },
                                        [_vm._v("จำนวน")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-20x border-right",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-lg text-monospace",
                                        },
                                        [_vm._v("เรทจ่าย")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-40x",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center text-lg text-monospace",
                                        },
                                        [_vm._v("ชนะ")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(
                            _vm._filter(_vm.lottoNumbersWithType, [
                              "type",
                              acceptant.slug,
                            ]),
                            function (lottoNumber, index) {
                              return _c("bet-recap", {
                                key: index,
                                staticClass: "w-100",
                                attrs: {
                                  item: lottoNumber,
                                  "master-slug": _vm.gameMasterName,
                                },
                                on: {
                                  "update:item": function ($event) {
                                    lottoNumber = $event
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex",
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex-width mx-1",
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 btn-danger w-100",
                      attrs: {
                        block: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("bv-modal-template")
                        },
                      },
                    },
                    [_vm._v(" ปิด ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex-width mx-1",
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-3 btn-yellow w-100",
                      attrs: {
                        block: "",
                      },
                      on: {
                        click: _vm.templateSubmit,
                      },
                    },
                    [_vm._v(" บันทึก ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "bv-modal-get-template",
            size: "xl",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [_vm._v(" รายการบันทึกโพย ")]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                "hide-overlay": "",
                persistent: "",
                "max-width": "290",
              },
              model: {
                value: _vm.dialogSubmit,
                callback: function ($$v) {
                  _vm.dialogSubmit = $$v
                },
                expression: "dialogSubmit",
              },
            },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    color: "red",
                    dark: "",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _vm._v("\n          กำลังประมวลผล\n          "),
                      _c("v-progress-linear", {
                        staticClass: "mb-0",
                        attrs: {
                          indeterminate: "",
                          color: "white",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-block text-center",
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-body mt-0 px-1 py-0 text-center",
                },
                _vm._l(_vm.templateLists, function (list, index) {
                  return _c(
                    "div",
                    {
                      key: list.index,
                      staticClass:
                        "d-flex border-bottom py-3 justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-width text-left align-items-center",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(list.name) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width text-right",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn py-2 btn-success",
                              on: {
                                click: function ($event) {
                                  return _vm.selectTemplate(list.numbers)
                                },
                              },
                            },
                            [_vm._v("เลือก")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn py-2 btn-danger",
                              on: {
                                click: function ($event) {
                                  return _vm.delTemplate(list.id)
                                },
                              },
                            },
                            [_vm._v("ลบ")]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "290",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "text-h6 text-center",
                },
                [_vm._v("\n        " + _vm._s(_vm.dialog_message) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialog = false), (_vm.deldigit = false)
                        },
                      },
                    },
                    [_vm._v(" ยกเลิก ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialog = false), _vm.confirmDelTemplate()
                        },
                      },
                    },
                    [_vm._v(" ยืนยัน ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card shadow-sm",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "card-header bg-primary d-flex justify-content-between text-white",
            },
            [
              _c("span", [_vm._v("รายการแทง")]),
              _vm._v(" "),
              !_vm.gameMasterSlug.startsWith("step_") &&
              !_vm.gameMasterSlug.startsWith("big_")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-xs btn-dark",
                      on: {
                        click: _vm.loadTemplate,
                      },
                    },
                    [_vm._v("\n        เลขชุด / ดึงโพย\n      ")]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: {
                id: "betForm",
                method: "POST",
                action: _vm.urlApiLottoBet,
                enctype: "multipart/form-data",
              },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-body px-1 pb-0 text-center",
                  attrs: {
                    id: "lottoViewTable",
                  },
                },
                _vm._l(_vm.accepTants, function (acceptant) {
                  return _c(
                    "div",
                    {
                      key: acceptant.slug,
                    },
                    [
                      _vm._filter(_vm.lottoNumbersWithType, [
                        "type",
                        acceptant.slug,
                      ]).length > 0
                        ? _c(
                            "h1",
                            {
                              staticClass:
                                "text-xl bg-black text-white text-left py-2 px-2 mx-1",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(acceptant.display) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(
                          _vm._filter(_vm.lottoNumbersWithType, [
                            "type",
                            acceptant.slug,
                          ]),
                          function (lottoNumber, index) {
                            return _c("bet-list", {
                              key: index,
                              staticClass: "w-100",
                              attrs: {
                                item: lottoNumber,
                                "game-master-slug": _vm.gameMasterSlug,
                              },
                              on: {
                                "update:item": function ($event) {
                                  lottoNumber = $event
                                },
                                "item-delete": _vm.digitClickReview,
                                "child-updateBetAmount": _vm.updateBetAmount,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-footer",
                },
                [
                  !_vm.gameMasterSlug.startsWith("step_") &&
                  !_vm.gameMasterSlug.startsWith("big_")
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex text-md align-items-center",
                        },
                        [
                          _c("v-text-field", {
                            staticClass: "w-100 py-0 mt-2",
                            attrs: {
                              suffix: "฿",
                              label: "เดิมพันราคาเท่ากันนะ",
                              outlined: "",
                              onfocus: "{ this.value = ''; }",
                              type: "tel",
                            },
                            on: {
                              input: function ($event) {
                                _vm.isTyping = true
                              },
                              paste: function ($event) {
                                return _vm.onPaste($event)
                              },
                              keypress: function ($event) {
                                return _vm.validateNumber($event)
                              },
                            },
                            model: {
                              value: _vm.priceQuery,
                              callback: function ($$v) {
                                _vm.priceQuery = $$v
                              },
                              expression: "priceQuery",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group d-flex text-lg",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width text-left",
                        },
                        [
                          _vm._v(
                            "จำนวน " +
                              _vm._s(_vm.lottoNumbersWithType.length) +
                              " เลข"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width text-right",
                        },
                        [
                          _vm._v(
                            "\n            รวม\n            " +
                              _vm._s(
                                _vm._sumBy(
                                  _vm.lottoNumbersWithType,
                                  function (item) {
                                    return parseInt(item.amount)
                                  }
                                )
                              ) +
                              "\n            ฿\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group d-flex",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-width",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-pink w-100 my-0 text-lg px-2",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: _vm.clearDegit,
                              },
                            },
                            [_vm._v("ล้าง")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "flex-width mx-1",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-warning w-100 my-0 text-lg px-2",
                              attrs: {
                                type: "button",
                              },
                              on: {
                                click: _vm.templateReview,
                              },
                            },
                            [_vm._v("\n              บันทึก\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex-width",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-success w-100 my-0 text-lg px-2",
            attrs: {
              type: "submit",
            },
          },
          [_vm._v("ส่งโพย")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }